import { render } from "./Section3.vue?vue&type=template&id=aa70ab6c"
import script from "./Section3.vue?vue&type=script&lang=js"
export * from "./Section3.vue?vue&type=script&lang=js"

import "./Section3.vue?vue&type=style&index=0&id=aa70ab6c&lang=css"

import exportComponent from "/Users/kimlong/Documents/Projects/Vuejs/adsota/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__